import React from 'react';
import { LinkButton, Typography } from 'fronton-react';
import { сreditStyles } from './styles';
import { GAClickButton } from 'utils';

export const Credit = () => {
	const onCreditClick = () => {
		GAClickButton({
			elementName: 'Кредит на ремонт',
			elementBlock: 'landingChernovoyRemont',
			elementText: 'Условия кредита',
		});
	};
	return (
		<div className={сreditStyles}>
			<div className="left">
				<div className="left__wrapper">
					<Typography className="left__typography" variant="h2" as="h2">
						Кредит на ремонт
					</Typography>
				</div>
			</div>
			<div className="right">
				<div className="right__pic">
					<img src="https://cdn.lemanapro.ru/lmru/image/upload/v1724679041/fudzi/elbrus/images/landings/rough-work/Icon container.png/Icon container.png" />
				</div>
				<div className="right__text-container">
					<Typography variant="h3" as="h3">
						Начните ремонт сейчас, платите потом!
					</Typography>
					<Typography className="wait-text" variant="m" size="body_long">
						Зачем ждать, ведь мы уже можем приступить к работам — просто оформите кредит
						в одном из наших магазинов
					</Typography>
					<LinkButton
						onClick={onCreditClick}
						href="/service/kredit/"
						className="cta-btn"
						size="m"
						variant="accent"
					>
						Условия кредита
					</LinkButton>
				</div>
			</div>
		</div>
	);
};
